<template>
  <div class="return-layout return">
    <div class="return-section stepper-container">
      <return-stepper
        :step="2"
        :isAtmRefund="isAtmRefund"
        :word="isRedmption ? '款' : '貨'"
      />
    </div>
    <div class="return-section mt-2">
      <div>訂單編號：</div>
      <div class="order-type">
        <div class="order-id">{{ orderNo }}</div>
        <div v-show="isGroupCoupon" class="product-type">成套票券</div>
        <div v-show="isGroupCoupon" class="return-word">
          成套票券所產生的訂單,未能於兌換期間內將整套/組憑證兌換完畢、或於兌換期間發生退款時,會先將已使用過的憑證轉換為原價,再進行退款相關處理。
        </div>
      </div>
    </div>
    <div class="return-section mt-2 pb-2">
      <div v-if="!isRedmption">
        <div>
          <p>1、退貨商品退回須知</p>
          <p>（1）、一般宅配商品、超商取貨商品</p>
          <p>我們將通知廠商，並安排物流人員盡快前往取件。</p>
          <p>
            若您還沒收到欲退貨的商品，我們將請廠商取消出貨，可能因時間差來不及取消出貨，請您拒收即可。
          </p>
          <p>
            另外如頁面（權益說明）有針對退貨商品定義其他規範，也請依頁面說明為主。
          </p>
          <p>（2）、實體票券商品</p>
          <p>
            因各票券商皆有不同規範，故退貨票券退回方式，請依頁面及權益說明處相關辦法為主，
            如未依頁面規定時間將票券寄回，恐影響您的退貨權益。
          </p>
          <p>2、確認商品完整性</p>
          <p>
            請保持商品本體、附件、內外包裝、配件、贈品、保證書、原廠包裝、所有隨附文件或資料的完整性；切勿缺漏任何配件或損毀原廠外盒。
            若商品屬瑕疵情形，請務必拍照，並將圖檔提供於客服中心，以避免爭議。
          </p>
          <p>3、包裝原則說明</p>
          <p>
            請儘量以原包裝紙箱將退貨商品包裝妥當，若原紙箱已遺失，請另使用其他紙箱包覆於商品原廠包裝之外，切勿直接於原廠包裝上黏貼紙張或書寫文字。
          </p>
          <p>4、退費金額計算</p>
          <p>
            按下【確認退貨】後，待廠商完成回收確認商品情形，或確認未出貨完畢後，即會進行退款作業，處理完畢將會另以電子信件通知您。退款金額將直接退至您的信用卡內，退款時間將因各家銀行作業時間不同而異，麻煩耐心等候。
          </p>
          <p>
            折扣碼為一次折抵，退貨無法返還。
          </p>
          <p>5 、無法退貨的特殊商品</p>
          <p>
            若商品為以下狀況，符合『通訊交易解除權合理例外情事適用準則』則排除七天猶豫期，恕無法接受退換貨申請：
          </p>
          <p>◆ 總保存期限低於七天（含）／易腐敗商品（如：牛奶、蛋糕）</p>
          <p>◆ 客製化商品（依您需求開通製作完成）</p>
          <p>◆ 報紙、期刊、雜誌、拆封後的電腦影音軟體、線上數位化服務</p>
          <p>◆ 已拆封的個人衛生用品</p>
          <p>
            商品若因本身瑕疵申請換貨者，則不在此限，請務必詳細拍照記錄（含：外箱、宅配單、瑕疵、總商品數量）。
          </p>
          <p>6、生鮮食品退貨方式</p>
          <p>
            ◆
            生鮮食品異常或有損毀情形發生，請立即拍照記錄並保留完整包裝，並將商品盡速置放到冷藏／冷凍設備儲存。
          </p>
          <p>◆ 請務必於到貨當日，來電或來信告知。</p>
          <p>7、退貨注意事項</p>
          <p>
            ◆
            商品在收貨7天猶豫期內可接受退貨，特殊商品退貨規則需依頁面權益說明為主。
          </p>
          <p>
            ◆
            於七天猶豫期內，若您逾越檢查之必要或因可歸責於您之事由，以致於商品有故障、破損、磨損、刮傷、沾染汙漬等毀損、滅失或變更之情形時，都可能會影響您退、換貨之權利。
            <br />
            當您申請退貨，即代表同意授權康太數位代為處理發票作廢及銷貨折讓單事宜。康太數位將於退貨完成後，開立電子折讓單並以電子信件方式通知。若您開立三聯式發票，退貨申請後，請務必將紙本折讓單列印蓋章寄回。
            <br />
            提醒您，退貨一經申請成功，將會退掉訂單內所有商品。取消退貨，請與客服中心聯繫。
          </p>
        </div>
      </div>
      <div v-else>
        <div v-if="termsFromApi" v-html="termsFromApi"></div>
        <div v-else>
          <p>1、退款說明</p>
          <p>
            按下【確認申請】後，待我們進行審核並確定完畢後，即會進行退款作業，處理完畢將會另以電子信件通知您。退款金額將直接透過Pi拍錢包退款，退款作業時間請參照Pi拍錢包內「關於Pi拍錢包」條款，麻煩耐心等候。
          </p>

          <p>
            折扣碼為一次折抵，退款無法返還。
          </p>
          <p>2、退款注意事項</p>
          <p>
            當您申請退款，即代表同意授權康太數位代為處理發票作廢及銷貨折讓單事宜。康太數位將於退款完成後，開立電子折讓單並以電子信件方式通知。
          </p>

          <p>
            提醒您，退款一經申請成功，將會退掉訂單內尚未使用的電子票券。按下【確認退款】後，即無法再取消退款。
          </p>
          <p>3、成套票券訂單</p>
          <p>
            成套票券所產生的訂單，未能於兌換期間內將整套/組憑證兌換完畢、或於兌換期間發生退款時，會先將已使用過的憑證轉換為原價，再進行退款相關處理。
          </p>

          <p>▶計算公式範例：</p>
          <p>
            特價金額- ( 原價x兌換商品數 ) = 退款金額
            一組電子票券4入原價400,特價250：
            <br />
            已兌換 1件,欲退款3件, 退款150元。
            <br />
            已兌換 2件,欲退貨 2件, 退款50 元。
            <br />
            已兌換 3件,欲退貨 1件, 退款0元。(餘額小於0)
            <br />
            已兌換 4件,欲退貨 0件, 退款0元。
          </p>
        </div>
      </div>
    </div>
    <div class="return-section mt-2 pb-2 bg-gray">
      <v-radio-group class="ma-0" v-model="acceptPolicy">
        <v-radio
          class="ma-0 py-2 policy__radio align-top"
          :label="
            isRedmption
              ? '我同意，由本平台代為處理發票及銷貨退回證明單，以加速退款作業。退款一經申請成功，將會退掉訂單內尚未使用的憑證。按下【確認退款】後，即無法再取消退款。'
              : '我同意，由本平台代為處理發票及銷貨退回證明單，以加速退貨退款作業。退貨一經申請成功，將會退掉訂單內所有商品。按下【確認退貨】後，即無法再取消退貨。'
          "
          :value="true"
          off-icon
        />
      </v-radio-group>
      <v-btn
        v-if="productType == 0"
        class="my-2 text-red justify-center"
        block
        color="primary"
        :outlined="!acceptPolicy"
        :disabled="!acceptPolicy"
        @click="nextStep"
      >
        {{ isRedmption ? '確認退款' : '確認退貨' }}
      </v-btn>
    </div>
    <WaitingOverlay v-model="submitting" />
  </div>
</template>

<script>
import ReturnStepper from '@/components/return/ReturnStepper.vue'
import WaitingOverlay from '@/components/shared/WaitingOverlay'

export default {
  name: 'ReturnPolicy',
  components: {
    ReturnStepper,
    WaitingOverlay,
  },
  data() {
    return {
      productType: 0, // redemption: 0 , delivery: 1
      orderNo: '',
      isAtmRefund: false,
      isGroupCoupon: false,
      acceptPolicy: false,
      submitting: false,
      returnInfo: null,
      termsFromApi: '',
    }
  },
  created() {
    this.orderNo = this.$route.query.orderNo
    this.productType = this.$route.query.type
    this.isAtmRefund = this.$route.query.isAtmRefund
    this.isGroupCoupon = this.$route.query.g
    this.returnInfo = JSON.parse(localStorage.getItem('returnInfo'))
    this.termsFromApi = JSON.parse(
      window.localStorage.getItem('initial_config')
    ).terms.returnPolicy
  },
  methods: {
    nextStep() {
      if (this.isAtmRefund) {
        this.$router.push({
          name: 'returnAtm',
          query: this.$route.query,
        })
      } else {
        this.sendReturnData()
      }
    },
    sendReturnData() {
      this.submitting = true
      if (this.isRedmption) {
        this.returnRedemption()
      } else {
        this.returnDelivery()
      }
    },
    goResult(result) {
      this.submitting = false
      this.$router.push({
        name: 'returnResult',
        query: {
          success: result,
          type: this.productType,
          isAtmRefund: this.isAtmRefund,
        },
      })
    },
    returnRedemption() {
      api
        .refund(
          this.orderNo,
          this.returnInfo.returnReasonOption == 15
            ? this.returnInfo.returnDetails
            : this.returnInfo.returnReason,
          this.returnInfo.returnReasonOption
        )
        .then(res => {
          if (res.data) {
            this.goResult(res.data.isSuccess)
          } else {
            this.goResult(false)
          }
        })
        .catch(err => {
          this.goResult(false)
          console.log(err)
        })
    },
    returnDelivery() {
      api
        .refund(
          this.orderNo,
          this.returnInfo.returnReasonOption == 7
            ? this.returnInfo.returnDetails
            : this.returnInfo.returnReason,
          this.returnInfo.returnReasonOption,
          null,
          this.returnInfo.isReceived,
          this.returnInfo.receiverName,
          this.returnInfo.receiverAddress,
          this.returnInfo.receiverPhone
        )
        .then(res => {
          if (res.data) {
            this.goResult(res.data.isSuccess)
          } else {
            this.goResult(false)
          }
        })
        .catch(err => {
          this.goResult(false)
        })
    },
  },
  computed: {
    isRedmption() {
      return this.productType == 0
    },
  },
}
</script>

<style scoped lang="scss">
.order-type {
  display: flex;
  flex-flow: row wrap;
}
.product-type {
  display: inline-block;
  min-width: 66px;
  height: 17px;
  border-radius: 8px;
  background-color: #fff6e0;
  color: #ff8c00;
  font-size: 12px;
  padding: 0 8px;
  margin: 2px 5px;
}
.return-layout {
  background-color: #f3f3f3;

  .return-section {
    background-color: white;
    box-shadow: 0 1px 0 0 #ededed;
    padding: 16px;
  }

  .stepper-container {
    padding: 0 20px;
  }
}
.return-word {
  color: #1da7fc;
}
</style>
